import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Button } from '@material-ui/core'
import { useIntl, FormattedMessage } from 'react-intl'

export default (props) => {
  const { email, open, setOpen, onAgree, emailRef } = props
  const { formatMessage } = useIntl()
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <FormattedMessage id="registerForm.dialog.title" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {formatMessage(
            {
              id: 'registerForm.dialog.content',
            },
            { email: email },
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false)
            emailRef.current.focus()
          }}
          color="primary"
        >
          <FormattedMessage id="registerForm.dialog.fixItButton.label" />
        </Button>
        <Button onClick={() => onAgree()} color="primary" autoFocus>
          <FormattedMessage id="registerForm.dialog.registerButton.label" />
        </Button>
      </DialogActions>
    </Dialog>
  )
}
